module.exports = __webpack_public_path__ + "resources/img/img_akamaiAAP_m.5d2d86f221047117e816574752c49f40.png";